import React from 'react'
import { connect } from 'react-redux'
import { Row } from 'antd'
import { withRouter } from 'react-router'
import AddorUpdateButton from './AddorUpdateButton'
import BackButton from './BackButton'

@connect((state) => ({
  siderWidth: state.style.siderWidth,
  siderCollapsed: state.style.siderCollapsed,
}))
class FormButton extends React.Component {
  render() {
    return (
      <Row
        justify='start'
        style={{
          width: `calc(100% - ${this.props.siderWidth})`,
          maxWidth: '100vw',
          padding: 16,
          bottom: 0,
          position: 'fixed',
          zIndex: 1,
          right: 16,
          left: 16 + this.props.siderWidth,
          backgroundColor: 'rgba(252,252,252,0.8)'
        }}
      >
        {this.props.children ?? (
          <>
            <div
              style={{
                width: '100%',
                display: 'flex',
                marginRight: '10%',
                flexDirection: 'rows',
                alignItems: 'center',
                justifyContent: 'space-around'
              }}
            >
              <BackButton {...this.props} />
              <AddorUpdateButton text={this.props.saveBtnTitle ?? 'Save'} {...this.props} />
            </div>
          </>
        )}
      </Row>
    )
  }
}

export default withRouter(FormButton)
